// Lines that are informational only (start with "Note"/"Remarque") - never an
// answerable field, so never required and never rendered as an input.
const NOTE_PATTERN = /^(Note|Remarque)\b/i;

// Fields likely to need more than a single line of free text.
const LONG_ANSWER_PATTERN = /description|note|comment|remarque/i;

const slugify = (label) =>
  label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const makeFields = (template, attachmentLabels = []) =>
  template
    .split("\n")
    .map((label) => label.trim())
    .filter(Boolean)
    .map((label) => {
      const isNote = NOTE_PATTERN.test(label);
      return {
        key: slugify(label),
        label,
        type: isNote ? "note" : LONG_ANSWER_PATTERN.test(label) ? "textarea" : "text",
        isRequired: !isNote && !/\bif any\b/i.test(label),
      };
    })
    .concat(
      attachmentLabels.map((label) => ({
        key: slugify(label),
        label,
        type: "attachment",
        isRequired: true,
      }))
    );

const item = (label, labelFr, template, templateFr, attachmentLabels = []) => ({
  label,
  labelFr,
  fields: makeFields(template, attachmentLabels),
  fieldsFr: makeFields(templateFr, attachmentLabels),
});

const incidentThirdDropdowns = {
  "Back Office": {
    "Internet Applications": [
      item("Campus Learning Merge Request", "Demande de fusion concernant l'apprentissage sur Campus", `User full names:
OLD eids:
CURRENT eids:
Old national store number:
Current national store number:
Name change (if any):`, `Noms complets des utilisateurs :
Anciens numeros d'identification (EID) :
Numeros d'identification (EID) actuels :
Ancien numero national de magasin :
Numero national de magasin actuel :
Changement de nom (if any):`),
      item("Campus or Hamburger University Access", "Acces a Campus ou a l'Universite du Hamburger", `Name:
EID:
Confirmed the user shows under existing accounts in GAM?:
In Clearview, confirmed there is an active Store Assignment for the user's reporting store?:
Cleared browser history and cache?:
Attempted login via Incognito or InPrivate browsing?:
Date and time of attempted login including time zone:`, `Nom :
EID :
Avez-vous verifie que l'utilisateur figure bien parmi les comptes existants dans GAM ?:
Dans Clearview, avez-vous verifie qu'il existe une affectation de magasin active pour le magasin de reference de l'utilisateur ?:
Avez-vous efface l'historique et le cache du navigateur ?:
Avez-vous essaye de vous connecter en mode de navigation privee ?:
Date et heure de la tentative de connexion, y compris le fuseau horaire:`, ["Full Screenshot of login error that shows the URL in the browser"]),
      item("Campus Missing Users", "Utilisateurs manquants sur Campus", `Full Name:
EID:
Name and EID of the user that is missing in Campus:`, `Nom complet :
EID :
Nom et EID de l'utilisateur qui manque dans Campus :`, ["Screenshot showing the user is assigned as the Organization manager", "Screenshot showing the EID is enabled/active in GAM"]),
      item("Campus Inactive Employees still showing", "Les employes inactifs sur Campus sont toujours affiches", `Full Names and EIDs of the users that are still showing in Campus:
Confirmed the employees have been terminated in Clearview with a permanent reason?:
For Franchise sites - attempted to resend employee from Clearview followed by 24hrs wait period?:`, `Noms complets et EID des utilisateurs qui apparaissent toujours dans Campus :
Avez-vous verifie que les contrats des employes ont bien ete termines dans Clearview avec une raison permanente ?
Pour les sites franchises : avez-vous essaye de renvoyer les donnees de l'employe provenant de Clearview, puis respecte un delai d'attente de 24 heures ?`, ["Screenshot"]),
      item("Campus courses not marked as completed", "Cours Campus non marques comme termines", `User name:
EID:
Name of course/module:
Device (ie ibos, training ipad etc):
Device browser:`, `Nom d'utilisateur :
EID :
Nom du cours/module :
Appareil (par exemple, ibos, iPad de formation, etc.) :
Navigateur de l'appareil :`, ["Screenshot"]),
      item("McD Connect", "McD Connect", `Employee Full Name:
EID:
User account is active in GAM[Y/N]:
Employee Status in Clearview[Active/Inactive]:
Clearview Store Assignment(s)[List stores]:
McD Connect Instance - Franchisee(mcdcanada) or McCoPcO(mcdcanmcopco):`, `Nom complet de l'employe :
EID :
Compte utilisateur actif dans GAM [Oui/Non] :
Statut de l'employe dans Clearview [Actif/Inactif] :
Affectation(s) a des magasins dans Clearview [Liste des magasins] :
Instance McD Connect - Franchise (mcdcanada) ou McOpCo (mcdcanmcopco) :`, ["Screenshot"]),
      item("McHire Access Issue", "Probleme d'acces a McHire", `User Name:
User EID:`, `Nom d'utilisateur :
Identifiant utilisateur :`, ["Screenshot of the error the user is receiving when attempting to access McHire", "Screenshot from GAM showing the user is assigned access to the application", "Screenshot from GAM showing the Franchisee has accepted the Paradox agreement"]),
      item("McHire Non-Access Issue", "Probleme lie a McHire (non lie a l'acces)", `User name:
Contact phone number:
User email:
User EID:
Description of issue:`, `Nom d'utilisateur :
Numero de telephone :
Adresse e-mail :
EID de l'utilisateur :
Description du probleme :`, ["Screenshot of issue"]),
      item("Medallia", "Medallia", `User Name:
User EID:
User Email:
Confirmed Medallia access granted to user in GAM:
Description of issue:`, `Nom d'utilisateur :
EID de l'utilisateur :
Adresse e-mail de l'utilisateur :
Acces a Medallia confirme pour l'utilisateur dans GAM :
Description du probleme :`, ["Screenshot of the issue"]),
    ],
  },
  Clearview: {
    Employee: [
      item("SuccessFactors Sync Issue", "Probleme de synchronisation avec SuccessFactors", `Affected Employee Full Name:
Employee Name:
Employee ID Number from SF or CV:
Employee Email address from SF:
Hire or Rehire or Termination Date:
For terminations - confirmed the termination date is one day after the last timecard in Clearview [Y/N]:
For reporting store changes - confirmed the effective date of the change is the first day of the next open pay period [Y/N]:
Note - If you answered Y to the two questions above, you will need to reach out to mcdonaldsandme@support.mcdonalds.com to make the corrections.
Full description of issue:`, `Nom complet de l'employe concerne :
Nom de l'employe :
Numero d'identification de l'employe issu de SF ou CV :
Adresse e-mail de l'employe dans SF :
Date d'embauche, de reembauche ou de depart :
Pour les departs - date confirmee selon la derniere carte de pointage [O/N] :
Pour changement de magasin - date effective confirmee [O/N] :
Remarque - Si vous avez repondu O, contactez mcdonaldsandme@support.mcdonalds.com.
Description complete du probleme :`, ["Screenshots"]),
      item("Incorrect EID on Blue Yonder tab", "EID incorrect dans l'onglet Blue Yonder", `CV ID:
Correct EID:
EID showing in CV:
Valid Email present in CV?:
For Franchise sites - If the user is a Swing Manager, confirmed hierarchy role assigned in Franchisee Proile Information (FPI)?:
For Franchise sites - Attempted resend followed by 24hrs?:`, `ID de CV :
EID valide :
EID affiche dans CV :
L'adresse e-mail indiquee dans CV est-elle valide ? :
Pour les sites franchises - role hierarchique confirme dans FPI ? :
Pour les sites franchises - renvoi tente suivi de 24 heures ? :`),
    ],
    "Cash Sheet": [
      item("Missing / Incorrect / Balance Warning", "Manquant / Errone / Avertissement - ecart", `Affected business day:
Cash Sheet Missing or Incorrect data or balance warning?:
ABC completed successfully followed by 30mins wait period?
Any ABC issue to report (i.e. One or more pos still on yesterday's date etc.)?`, `Jour ouvrable concerne :
Sommaire de caisse manquant, incorrect ou avertissement de solde ?:
Processus ABC complete suivi de 30 minutes d'attente ?
Probleme ABC a signaler ?`),
    ],
    Reports: [
      item("Variance Report with Waste", "Rapport sur ecarts avec pertes", `Date range of the report:
Affected item(s):
Variance amount:
Confirmed quantities received on invoices from Martin Brower are correct [Y/N]:
Confirmed the counts in the reporting period were not closed prior to the sales/pmix being present for each day in Clearview [Y/N]:
Attempted to reopen/close the counts [Y/N]:
For low theoretical usage, confirmed the inventory flag was set to yes prior to item being sold [Y/N]:
Note - tracking of theoretical usage is dependant on the inventory flag being set to yes. If this was not set in time, the service desk cannot assist.`, `Periode couverte par le rapport :
Article(s) concerne(s) :
Montant de l'ecart :
Quantites recues confirmees correctes [O/N] :
Inventaires non clotures avant les donnees de ventes/pmix [O/N] :
Tentative de reouverture/cloture [O/N] :
Drapeau d'inventaire active avant la vente [O/N] :
Remarque : le suivi depend de l'activation du drapeau d'inventaire.`),
    ],
    Inventory: [
      item("Missing Item on Count", "Article manquant lors du comptage", `Count date:
Inventory Item Name:
Product Code:
Confirmed the item is active?:
Confirmed the inventory flag is set to yes?:
For mini counts - attempted to use the 'add item' button?:
For full counts - attempted to use the 'check inventory items' button?:
If the item was manually added to any count sheets, attempted to remove it from the sheets and use either method above to add the item to the count?:`, `Date de l'inventaire :
Nom de l'article en inventaire :
Code produit :
Article actif confirme ? :
Drapeau d'inventaire active confirme ? :
Pour mini-inventaires - bouton Ajouter un article tente ? :
Pour inventaires complets - bouton Verifier les articles tente ? :
Si ajoute manuellement, avez-vous tente de le supprimer puis de l'ajouter avec une methode ci-dessus ? :`),
    ],
  },
  "LSM-Blue Yonder": {
    "Integration-Data": [
      item("Employee sync Issue with Clearview", "Probleme de synchronisation des employes avec Clearview", `Employee Name:
CV ID:
BY Badge:
McD EID:
Employee status (active/inactive):
Current reporting store:
Active Store Assignments:
Punch Rule:
Security Role:
Login Permissions:
For terminations - CV termination date:
For terminations - confirmed that there are no scheduled/punched hours or pay adjustments in BY after the termination date[Y/N]:
For terminations - confirmed there are no time off requests in BY after the termination date[Y/N]:`, `Nom de l'employe :
Identifiant CV :
Badge BY :
EID McD :
Statut de l'employe (actif/inactif) :
Magasin de rattachement actuel :
Affectations en cours :
Regle de pointage :
Role de securite :
Autorisations de connexion :
Pour les departs - date de terminaison CV :
Aucune heure/apport apres la date de terminaison [O/N] :
Aucune demande de conge apres la date de terminaison [O/N] :`),
    ],
    "Log-in": [
      item("WFM App", "l'appli WFM", `Restaurant Type (McOpCo / Franchise):
Employee Full Name:
Employee Role (Crew / Manager / Owner Operator / Ops Consultant):
ClearView Employee ID:
BY Badge #:
User EID showign in Clearview:
User EID showing in GAM:
Valid Email Present in ClearView?:
Punch Rule:
Security Role:
Login Permissions (for CREW only 1 store should be selected and it must be the same as the reporting store):
User's account has been reset in GAM?:
For Franchise sites - Attempted to resend the employee from Clearview followed by 24hr wait period?:`, `Type de restaurant (McOpCo / Franchise) :
Nom complet de l'employe :
Fonction de l'employe :
Identifiant ClearView :
Numero de badge BY :
EID affiche dans ClearView :
EID affiche dans GAM :
Adresse e-mail valide dans ClearView ? :
Regle de pointage :
Role de securite :
Autorisations de connexion :
Compte reinitialise dans GAM ? :
Pour franchises - renvoi depuis ClearView suivi de 24h ? :`),
      item("Web Application - User with a CV employee record", "Application Web - Utilisateur disposant d'un dossier d'employe avec CV", `User Full Name:
CV ID:
BY Badge:
McD EID:
Punch Rule:
Security Role:
Login Permissions:
CV Job Code:
BY Job:
Attempted to toggle login permissions? [Y/N]:`, `Nom complet de l'utilisateur :
Identifiant CV :
Badge BY :
EID McD :
Regle de pointage :
Role de securite :
Autorisations de connexion :
Code de poste CV :
Poste BY :
Tentative de modifier les autorisations [O/N] :`),
      item("Web Application - User without a CV employee record", "Application Web - Utilisateur ne disposant pas d'un dossier d'employe avec CV", `User Full Name:
McD EID:
BY Access set to yes from CV system users? [Y/N]:
Security Role:
Login Permissions:
Attempted to toggle login permissions? [Y/N]:`, `Nom complet de l'utilisateur :
EID McD :
Acces BY active depuis les utilisateurs systeme CV ? [O/N] :
Role de securite :
Autorisations de connexion :
Tentative de modifier les autorisations [O/N] :`),
    ],
  },
};

export default incidentThirdDropdowns;
